/**
 * Постепенный переход на новый компонент
 * Старый будует убран когда будет редизайн боковой карточки
 */

import * as React from 'react';
import { useSelector } from 'react-redux';

import { ApprovalNew, EApprovalType } from '../../components/Approval/ApprovalNew';
import { ApprovalNewWrapper } from '../../components/ApprovalNewWrapper';
import { selectAgentLevelInfo, selectHasVerifiedDocuments } from '../../selectors';

export const ApprovalContainerNew = () => {
  const agentLevelInfo = useSelector(selectAgentLevelInfo);
  const hasVerifiedDocuments = useSelector(selectHasVerifiedDocuments);

  const hasVerifiedDocumentsApproval = agentLevelInfo?.hasVerifiedDocuments || hasVerifiedDocuments;

  if (!hasVerifiedDocumentsApproval) {
    return null;
  }

  return (
    <ApprovalNewWrapper>
      {hasVerifiedDocumentsApproval && <ApprovalNew type={EApprovalType.HasVerifiedDocuments} />}
    </ApprovalNewWrapper>
  );
};
